export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-odims-product').forEach((product) => {
      let resetMaxStock = (current_stock, instance) => {
        document
          .querySelectorAll('input.js-product_current_stock')
          .forEach((el) => {
            if (el.max) {
              el.max = parseInt(current_stock)
            }
            el.value = 1
          })
        if (current_stock <= 0) {
          document.dispatchEvent(
            new CustomEvent('odims:product:outofstock', { detail: instance })
          )
        }
      }
      fetch(
        '/api/prod/products/' +
          product.dataset.id +
          '.json?disable_related_products=true&disable_blog_articles=true'
      ).then((res) => {
        res.json().then((data) => {
          resetMaxStock(data.product.current_stock, product)
          //update product_variants' current_stock from data.variants
          let any_checked = false
          data.product.variants.forEach((variant) => {
            document
              .querySelectorAll(
                'input.js-product-variant[value="' +
                  variant.id +
                  '"], select.js-product-variant option[value="' +
                  variant.id +
                  '"]:checked'
              )
              .forEach((el) => {
                if (variant.current_stock <= 0) {
                  el.disabled = true
                  el.checked = false
                  resetMaxStock(variant.current_stock, variant)
                } else {
                  if (!any_checked) {
                    any_checked = true
                    el.checked = true
                    resetMaxStock(variant.current_stock, variant)
                    // trigger event 'odims:product:variant:selected'
                    document.dispatchEvent(
                      new CustomEvent('odims:product:variant:selected', {
                        detail: variant,
                      })
                    )
                  } else {
                    el.checked = false
                  }
                }
              })
          })
        })
      })
    })
  })
})()
